import React, { type ComponentProps, useMemo } from 'react'

import { Badge } from 'slab'

import { PRODUCT_CATEGORIES } from '../../../marketplace/shared'
import { type MarketplaceProductCategory } from '../../../marketplace/shared/types'

interface MarketplaceProductBadgeProps {
  category: MarketplaceProductCategory
}

type IconProp = ComponentProps<typeof Badge>['leftIcon']

const MarketplaceProductBadge: React.FC<MarketplaceProductBadgeProps> = ({ category }) => {
  const productCategory = useMemo(() => {
    let productCategory: {
      category: MarketplaceProductCategory;
      Icon: React.ElementType;
      displayName: string;
    } | undefined

    for (const c of PRODUCT_CATEGORIES) {
      if (c.category === category) {
        productCategory = c
        break
      }

      // Fallback to All category if no match is found
      if (c.category === 'All') {
        productCategory = c
      }
    }

    return productCategory
  }, [category])

  return (
    <div className='whitespace-nowrap'>
      <Badge
        type='thatch'
        bordered
        leftIcon={productCategory?.Icon as IconProp}
      >
        <span className='font-light'>{productCategory?.displayName}</span>
      </Badge>
    </div>
  )
}

export default MarketplaceProductBadge
